import { NgModule } from '@angular/core';

import { BetaGroupDialogComponent } from './beta-group.component';

@NgModule({
    imports: [],
    exports: [BetaGroupDialogComponent],
    declarations: [BetaGroupDialogComponent],
    providers: [],
  entryComponents: [BetaGroupDialogComponent]
})
export class BetaGroupModule { }

